/**
 * Centralised so the wizard and the inline docs hints all anchor into the
 * same onboarding doc article. Each stage and each user-facing field has a
 * matching `## Heading` / `### Heading` in
 * `docs/public/administration/organization-onboarding.page.json`, and
 * `rehype-slug` produces the kebab-case anchor names passed here.
 * `__tests__/onboarding-docs-anchors.test.ts` guards the anchors against
 * heading drift.
 */
const ONBOARDING_DOC_SLUG = 'administration/organization-onboarding';

export const docs = (anchor: string): string => `${ONBOARDING_DOC_SLUG}#${anchor}`;
